/* eslint no-console:0 */
import "../css/application.css";
import "bootstrap";
import "./utils/license_mui_x_pro";

// polyfill for legacy modules depending on "global"
// https://github.com/bevacqua/dragula/issues/602#issuecomment-477734315
if (typeof window.global === "undefined") {
  window.global = window;
}
